export class EcgMeasures {
    A1: number = 0;
    A2: number = 0;
    deltaT: number = 0;
    deltaA: number = 0;
    HR: number = 0;
}
